module.exports = __webpack_public_path__ + "img/kankou_6.9d4b4d78.jpg";